const CryptoJS = require('crypto-js');
import { getEnv } from 'webmd-url';

if (typeof(window) !== 'undefined') {
	if (document.location.hostname !== 'localhost') {
		var urlEnv = getEnv();
	} else {
		var urlEnv = 'localhost';
	}
}

const webmdOauth = {

	webmdEnv: '',
	/**
	 * Generates an oauth object to send with requests for solr search APIs
	 * @param {object} options
	 * @returns {object}
	 */
	generate(options, env) {
		const self = this;
		self.webmdEnv = env || self.getEnv();
		const settings = Object.assign({}, self.getDefaults(), options);
		const currentTime = new Date();
		const timestamp = (currentTime.getTime() - currentTime.getMilliseconds()) / 1000;
		const valueToHash = '{{timestamp:'+timestamp+',client_id:'+settings.client_id+'}}';
		console.log('hashh', settings.secret_key);
		const hash = CryptoJS.HmacSHA256(valueToHash, settings.secret_key.toLowerCase());
		const hashInBase64 = CryptoJS.enc.Base64.stringify(hash);

		if (!CryptoJS) {
			console.error('webmd.oauth error: CryptoJS module not loaded');
		} else {
			return {
				enc_data: hashInBase64,
				timestamp: (currentTime.getTime() - currentTime.getMilliseconds()) / 1000,
				client_id: settings.client_id,
				client_secret: settings.secret_key,
			};
		}
		return {};
	},

	/**
	 * Get the default environment
	 * @returns {object}
	 */
	getEnv() {
		return urlEnv;
	},
	/**
	 * Get the default per environment
	 * @returns {object}
	 */
	getDefaults() {
		const self = this;
		switch (self.webmdEnv) {
			case 'localhost':
			case '.dev01':
			case '.dev02':
			case '.dev03':
			case '.dev04':
			case '.devint':
			case '.feature':
				console.log('dev auth');
				return {
					client_id: '28c8b711-b6b8-440c-9e78-d56a1bcc4aa2',
					secret_key: '28d3027f-75c7-4e1a-9806-3c790c430d95',
				};
			case '.qa01':
			case  '.qa':
				console.log('qa auth');
				return {
					client_id: '6d583099-1dee-4ead-962f-b736b162cfe5',
					secret_key: 'd25e940c-482d-46e9-b2d4-6f987f528d26',
				};

			case '.qa00':
				console.log('qa00 auth');
				return {
					client_id: '91cf0723-200a-43b2-8107-078e3d8f3406',
					secret_key: 'bb1f7fc7-9db8-4542-b289-c0b57775cd61',
				};
			case '.staging':
				console.log('staging auth');
				return {
					 client_id: '63bc91e1-0492-46eb-bb4a-042d6c924c4b',
					 secret_key: '5ec534d1-0bc0-4f82-b807-73e9d6c4031e',
				};

			// Production
			default:
				console.log('prod auth');
				return {
					 client_id: '63bc91e1-0492-46eb-bb4a-042d6c924c4b',
					 secret_key: '7d7b6252-4a25-4ea6-a4b3-45dc4ce8229f',
				};
		}
	},
};

export default webmdOauth;

